import { OccupationAPIPromiseClient } from "../../../gen/witbooking/backoffice/occupation/v1/occupation_api_grpc_web_pb";
import {
  GetAllOccupationsRequest,
  GetOccupationRequest,
  UpdateOccupationRequest,
  Occupation,
  Translation,
  DeleteOccupationRequest,
  CreateOccupationRequest,
} from "../../../gen/witbooking/backoffice/occupation/v1/occupation_api_pb";
import { buildGrpcClient } from "../../../lib/grpc";
import { OccupationEntity } from "../domain/occupation.entity";

const occupationClient: OccupationAPIPromiseClient = buildGrpcClient(OccupationAPIPromiseClient);

function translationFromObject(obj: Translation.AsObject): Translation {
  const result = new Translation();
  result.setLocale(obj.locale);
  result.setName(obj.name);
  result.setDescription(obj.description);
  return result;
}
function occupationFromObject(obj: OccupationEntity): Occupation {
  const result = new Occupation();
  result.setId(obj.id);
  result.setTicker(obj.ticker);
  result.setTranslationsList(obj.translationsList.map(translationFromObject));
  result.setSeniors(obj.seniors);
  result.setAdults(obj.adults);
  result.setJuniors(obj.juniors);
  result.setChildren(obj.children);
  result.setBabies(obj.babies);
  return result;
}

export async function getAllOccupations(token: string): Promise<OccupationEntity[]> {
  const request = new GetAllOccupationsRequest();
  const response = await occupationClient.getAllOccupations(request, {
    Authorization: `Bearer ${token}`,
  });
  return response
    .getOccupationsList()
    .map(m => ({ ...m.toObject(), autoGenerateTranslations: true }));
}

export async function getOccupation(id: string, token: string): Promise<OccupationEntity> {
  const request = new GetOccupationRequest();
  request.setId(id);
  const response = await occupationClient.getOccupation(request, {
    Authorization: `Bearer ${token}`,
  });
  const occupation = response.getOccupation();
  if (!occupation) {
    throw new Error("Unexpected reply obtaining occupation");
  }
  return { ...occupation?.toObject(), autoGenerateTranslations: true };
}

export async function updateOccupation(entity: OccupationEntity, token: string): Promise<void> {
  const request = new UpdateOccupationRequest();
  request.setOccupation(occupationFromObject(entity));
  await occupationClient.updateOccupation(request, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createOccupation(entity: OccupationEntity, token: string): Promise<string> {
  const request = new CreateOccupationRequest();
  request.setOccupation(occupationFromObject(entity));
  const response = await occupationClient.createOccupation(request, {
    Authorization: `Bearer ${token}`,
  });
  const createdOccupation = response.getOccupation();
  if (!createdOccupation) {
    throw new Error("Failed to create occupation");
  }
  return createdOccupation.getId();
}

export async function deleteOccupation(id: string, token: string): Promise<void> {
  const request = new DeleteOccupationRequest();
  request.setId(id);
  await occupationClient.deleteOccupation(request, {
    Authorization: `Bearer ${token}`,
  });
}
